export default "__VITE_ASSET__$_T4ABwv__"